import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cartSizeSelector } from 'redux/selectors/cart.selector';
import { useDispatch, useSelector } from 'react-redux';
import { CART_TOGGLE } from 'redux/constants/cart.constants';
import CartContainer from 'containers/CartContainer';
import './CartPopup.scss';

const CartPopup = (props) => {
    const { cartSize, } = props;

    const isCartOpen = useSelector(state => state.cart.isOpen);

    const dispatch = useDispatch();
    const toggleCart = () => {
        dispatch({ type: CART_TOGGLE })
    };
    
    return  (
      <>
        <div className="cart-popup" onClick={(e) => {
            e.preventDefault();
            toggleCart();
          }}>
            <i className="fa fa-shopping-cart cart-popup-icon" aria-hidden="true" />
            <span id="checkout-items" className="checkout-items">
              {cartSize}
            </span>
          </div>
          
        <div className={`cart-container mobile-cart ${isCartOpen ? 'visible' : ''}`}>
        <div className='cart-card-header' onClick={toggleCart}>
          <h4 className='text-center text-carrito'>Carrito de compras</h4>
          <h4 className="cart-close-button" > X</h4>
        </div>
        <div className="cart-content">
          <CartContainer 
           isCartOpen={isCartOpen}
           toggleCart={toggleCart}
           />
        </div>
        </div>
      </>
    );
};
  
  const mapStateToProps = (state) => ({
    cartSize: cartSizeSelector(state),
  });

  CartPopup.defaultProps = {
    isCartOpen: false,
  };
  
  CartPopup.propTypes = {
    cartSize: PropTypes.number,
  };
  
  export default connect(mapStateToProps)(CartPopup);
